/* eslint-disable @typescript-eslint/member-ordering */
import { CheckFn, InputStatus } from './input-status';
import { StatusMessage } from './status-message';

export class ValidationErrorStatus {
    private static _create = (error: string, message?: StatusMessage) =>
        InputStatus.create((control) => control.touched && control.hasError(error), 'danger', message);

    /**
     * TODO control.touched doesn't work with file input, ask fede a workaround
     * now it fires immediatly the error
     */
    public static FILE_REQUIRED = () => {
        return InputStatus.create((control) => control.hasError('required'), 'danger', {
            text: 'VALIDATIONS.REQUIRED'
        });
    };

    public static YEAR_DATE = () => {
        return InputStatus.create((control) => control.hasError('year_date'), 'danger', {
            text: 'VALIDATIONS.ERROR.YEAR'
        });
    };

    public static FILE_DIMENSION = () => {
        return InputStatus.create((control) => control.hasError('file_dimension'), 'danger', {
            text: 'VALIDATIONS_FILE_DIMENSION_NOT_VALID'
        });
    };

    public static FILE_NAME_NOT_VALID = () => {
        return InputStatus.create(
            (control) => {
                return control.hasError('file_name_not_valid');
            },
            'danger',
            {
                text: 'VALIDATIONS_FILE_NAME_NOT_VALID'
            }
        );
    };
    public static CUSTOM = (checkFn: CheckFn, message?: StatusMessage) =>
        InputStatus.create(checkFn, 'danger', message);

    public static REQUIRED_WITH_MESSAGE = (message?: StatusMessage) => this._create('required', message);

    public static REQUIRED = this.REQUIRED_WITH_MESSAGE({
        text: 'VALIDATIONS.REQUIRED'
    });

    public static NEGATIVE_VALUE = () => {
        return InputStatus.create((control) => control.hasError('negative_value'), 'danger', {
            text: 'VALIDATIONS_NEGATIVE_VALUE'
        });
    };

    public static DATE_BEFORE_MIN = () => {
        return InputStatus.create((control) => control.hasError('date_before_min'), 'danger', {
            text: 'VALIDATIONS_DATE_BEFORE_MIN'
        });
    };

    public static DATE_AFTER_MAX = () => {
        return InputStatus.create((control) => control.hasError('date_after_max'), 'danger', {
            text: 'VALIDATIONS_DATE_AFTER_MAX'
        });
    };

    public static NUMBER_BEFORE_MIN = () => {
        return InputStatus.create((control) => control.hasError('number_before_min'), 'danger', {
            text: 'VALIDATIONS_NUMBER_BEFORE_MIN'
        });
    };

    public static NUMBER_AFTER_MAX = () => {
        return InputStatus.create((control) => control.hasError('number_after_max'), 'danger', {
            text: 'VALIDATIONS_NUMBER_AFTER_MAX'
        });
    };

    public static DATE_INPUT_TEXT_NOT_VALID = () => {
        return InputStatus.create((control) => control.hasError('not_valid_date'), 'danger', {
            text: 'VALIDATIONS_NOT_VALID_DATE_INPUT_TEXT'
        });
    };

    public static PATTERN_REGEXP = this._create('pattern', { text: 'VALIDATIONS.PATTERN.REGEXP' });
}
